import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Charts from '../../common/Charts/Charts';
import settingsIcon from '../../../images/salescatalyst/configuration_icon_default.png';
import { NO_DATA_AVAILABLE_MSG } from '../../../messages/messages';
import { processChartData, processChartConfigData, calcChartHeight } from '../../../util/SalesCatalystUtils';
import { SC_CHART_CONFIG } from '../../../constants';
import ReportSortOptions from '../../common/ReportSort';
import SalesCatalystSectionBottom from '../SalesCatalystSectionBottom';

class SalesCatalystChart extends Component {

  constructor(props) {
    super(props);
    this.state = {
      chartData: processChartData(this.props.data, this.props.sortInfo),
      chartMsg: this.props.message !== undefined ? this.props.message : NO_DATA_AVAILABLE_MSG,
      sortOptionRef: undefined,
      sortInfo: this.props.sortInfo !== undefined ? this.props.sortInfo : {},
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({
        chartData: processChartData(nextProps.data, this.state.sortInfo),
      });
    }
    if (this.props.message !== nextProps.message) {
      this.setState({
        chartMsg: nextProps.message,
      });
    }
    if (!_.isEqual(this.props.sortInfo, nextProps.sortInfo)) {
      this.setState({
        chartData: processChartData(this.props.data, nextProps.sortInfo),
      });
    }
  }

  drawChartCategoryList = () => {
    const categories = this.state.chartData.categories;
    const itemHeight = (calcChartHeight(categories) - (SC_CHART_CONFIG.marginTop
      + SC_CHART_CONFIG.marginBottom)) / categories.length;
    return (
      <ul style={{ marginTop: `${SC_CHART_CONFIG.marginTop}px` }}>
        {_.map(categories, item =>
          (<li key={item.expression} style={{ height: `${itemHeight}px`, lineHeight: `${itemHeight}px` }}><span title={item.label}>{item.label}</span></li>))
        }
      </ul>
    );
  }

  showSortOptions = sortOptionRef => {
    this.setState({
      sortOptionRef,
    });
  }

  sortChartData = sortVal => {
    if (sortVal !== undefined) {
      const { index, type, sortBy } = sortVal;
      this.props.sortFn({
        index,
        type,
        sortBy,
      });
    }
    this.setState({
      sortOptionRef: undefined,
    });
  };

  editSubEntitiesList = () => {
    const categories = this.state.chartData.categories;
    this.props.editSubEntitiesFn(categories);
  }

  renderChartHeading = index => {
    return (
      <div>
        <div className="sc-chart-h-label label-ellipsis" style={{ maxWidth: '95%', display: 'inline-block' }} title={this.state.chartData.groups[index]}>{this.state.chartData.groups[index]}</div>
        <div className="sc-chart-sort salesPdfFlag" >
          <ReportSortOptions
            btnClickFn={() => this.showSortOptions(index)}
            selectedRef={this.state.sortOptionRef}
            index={index}
            sortReportChart={this.sortChartData}
            enableSortArrow
          />
        </div>
      </div>
    );
  }

  renderChartName = () => {
    return (
      <div className="sc-chart-h-label label-ellipsis">
        {(!this.props.universityUser) &&
          <button className="margin-right-5">
            <img className="sc-icon-img-sm salesPdfFlag" onClick={this.editSubEntitiesList} src={settingsIcon} alt="Settings" />
          </button>
        }
        <span title={this.state.chartData.label}>{this.state.chartData.label}</span>
      </div>
    );
  }

  render() {
    return (
      <div className="sc-chart-container padding-top-10">
        {this.state.chartData.categories.length > 0 && this.state.chartData.groups.length === 1 &&
          <div>
            <div className="row expanded scMediaPdfChartGraphSectionMargin">
              <div className="small-5 columns text-align-right">
                {this.renderChartName()}
              </div>
              <div className="small-7 columns text-align-left">
                {this.renderChartHeading(0)}
              </div>
            </div>
            <div className="row expanded scMediaPdfChartGraphSectionMargin">
              <div className="small-5 columns sc-chart-category-list align-r padding-left sc-chart-category-list-pdf">
                {this.drawChartCategoryList()}
              </div>
              <div className="small-7 columns">
                <Charts
                  config={processChartConfigData(
                    this.props.studyInfo,
                    this.state.chartData.categories,
                    this.state.chartData.chartFirst,
                    this.state.chartData.maxVal, 
                  )}
                />
              </div>
            </div>
          </div>
        }
        {this.state.chartData.categories.length > 0 && this.state.chartData.groups.length > 1 &&
          <div>
             <div className="small-5 columns text-align-center sc-graph-center-section-pdf-heading
              sc-brand-persona-graph-heading">
             RETENTION
             </div>
             <div className="small-2 columns">
               &nbsp;
              </div>
             <div className="small-5 columns text-align-center sc-graph-center-section-pdf-heading
             sc-brand-persona-graph-heading">
             ACQUISITION
             </div>
            <div className="row expanded scMediaPdfChartGraphSectionMargin">
              <div className="small-5 columns text-align-center sc-graph-section-pdf-heading">
                {this.renderChartHeading(0)}
              </div>
              <div className="small-2 columns text-align-center sc-graph-center-section-pdf-heading">
                {this.renderChartName()}
              </div>
              <div className="small-5 columns text-align-center sc-graph-center-section-pdf-heading">
                {this.renderChartHeading(1)}
              </div>
            </div>
            <div className="row expanded scMediaPdfChartGraphSectionMargin">
              <div className="small-5 columns pdf-charts" >
                <Charts
                  config={processChartConfigData(
                    this.props.studyInfo,
                    this.state.chartData.categories,
                    this.state.chartData.chartFirst,
                    this.state.chartData.maxVal,
                    {
                      yAxisReversed: true,
                    }                    
                  )}
                />
                &nbsp;
              </div>
              <div className="small-2 columns sc-chart-category-list pdf-charts">
                {this.drawChartCategoryList()}
              </div>
              <div className="small-5 columns pdf-charts">
                <Charts
                  config={processChartConfigData(
                    this.props.studyInfo,
                    this.state.chartData.categories,
                    this.state.chartData.chartSecond,
                    this.state.chartData.maxVal,
                    {
                      barColor: SC_CHART_CONFIG.colors[1],
                    }                    
                  )}
                />
              </div>
            </div>
          </div>
        }
        {this.state.chartData.categories.length === 0 ?
          <div className="row expanded">
            <div className="columns text-align-center">
              {this.state.chartMsg}
            </div>
          </div>
          : <SalesCatalystSectionBottom asteriskInfo />
        }
      </div>
    );
  }
}

SalesCatalystChart.defaultProps = {
  universityUser: false,
};


SalesCatalystChart.propTypes = {
  data: PropTypes.shape({}),
  message: PropTypes.string,
  sortFn: PropTypes.func,
  sortInfo: PropTypes.shape({}),
  editSubEntitiesFn: PropTypes.func,
  universityUser: PropTypes.bool,
  studyInfo: PropTypes.shape({})
};

export default SalesCatalystChart;
